// extracted by mini-css-extract-plugin
export var hideEditor = "_jv-2";
export var infoIcon = "_jv-3";
export var label = "_jv-1";
export var labelContainer = "_jv-0";
export var readonlyText = "_jv-4";